(function autoCloseDetails() {
  /** @param {EventTarget | null} target */
  function closeOutside(target) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(target instanceof Node && element.contains(target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    closeOutside(event.target);
  });

  document.addEventListener('focusin', function () {
    // Check the settled destination, not focusout's relatedTarget: a filter
    // refresh can briefly detach the focused input or move focus again.
    // A view transition can pause animation frames while filter results load.
    // A microtask lets focus settle without delaying keyboard dismissal.
    queueMicrotask(() => {
      const activeElement = document.activeElement;
      if (
        !activeElement?.isConnected ||
        activeElement === document.body ||
        activeElement === document.documentElement
      ) {
        return;
      }

      // Keep native Tab order. Only Escape explicitly restores trigger focus.
      closeOutside(activeElement);
    });
  });
})();
